/**
 * useNoindex — adds <meta name="robots" content="noindex"> to <head> while
 * the calling component is mounted, and removes it on unmount.
 *
 * Used by surfaces that must stay out of search indexes but are not
 * separable at the robots.txt level: the marketing-route scaffolds
 * (placeholder pages that become indexable when their real page lands) and
 * the 404 page. Issue SEO-008 / SEO-006.
 *
 * Client-side injection covers JS-rendering crawlers today. Once the public
 * routes are prerendered (SEO-001/002) the tag is baked into the static
 * HTML, so non-JS answer-engine crawlers see it too.
 */
import { useEffect } from "react";

export function useNoindex() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"][data-noindex]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      meta.setAttribute("data-noindex", "");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex");
    return () => {
      if (created && meta && meta.parentNode) {
        meta.parentNode.removeChild(meta);
      }
    };
  }, []);
}
